<div class="header-navigation-back">
  <mat-icon (click)="onNavigateToProfile()">arrow_back</mat-icon>
  <span class="title">Identity Check</span>
</div>
<div >
  <div class="padding-left-md" [innerHTML]="html"></div>
</div>
